module.exports = __webpack_public_path__ + "img/logo.bb784e90.svg";